<template>
    <div class="notice-popup">
        <div class="modal-container vstack">
            <div class="w-100">
                <img :src="$commonUtils.getImageUrl(notice.notice_image)" class="w-100" :class="{ 'cursor-pointer': notice.image_link }" v-if="notice.show_type === 'IMAGE' || notice.show_type === 'MULTI'" @click="onImageClick()" />
                <p class="fw-600" style="padding : 16px 16px 0px 16px"  v-html="notice.notice_title" v-if="notice.show_type === 'TEXT' || notice.show_type === 'MULTI' || notice.show_type === 'HTML'"></p>
                <p class="p-16" v-html="notice.notice_content" v-if="notice.show_type === 'TEXT' || notice.show_type === 'MULTI' || notice.show_type === 'HTML'"></p>
            </div>
            <div class="footer w-100 hstack">
                <button class="btn w-50 fs-14 fw-600" style="padding: 12px 0px;" @click="hideRecentNotice">다시 보지 않기</button>
                <button class="btn w-50 fs-14 fw-600" style="padding: 12px 0px;" @click="closeModal">닫기</button>
            </div>
        </div>
        
    </div>
</template>
<script>

export default {
    name: "NoticeModal",
    props: {
        notice: {
            type: Object,
            required: true
        }
    },
    data() {
        return {

        }
    },
    methods: {
        closeModal() {
            this.$emit('update:showModal', false);
        },

        hideRecentNotice(){
            this.$cookies.set('hide_notice_idx', this.notice.notice_idx );

            this.closeModal();
        },
        onImageClick(){
            if(this.notice.image_link && this.notice.image_link.length > 0){
                window.open(this.notice.image_link, '_blank');
            }
        }
    }    
}
</script>
<style scoped>
    @import "@/css/common.css";
    @import "@/css/style.css";

    .notice-popup {
        position: fixed;
        /* 중앙에 위치 */
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 30%;
        max-width: 600px;
        max-height: 90%;
        background-color: #fff;
        display: flex;
        z-index: 9999;

        @media (max-width: 768px) {
            width: 90%;
            max-width: 90%;
            
        }
    }

    .modal-container {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        position: relative;
    }

</style>